import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { EmbeddedComponent } from '@maximizer/core/shared/ui/components/base';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { OutlookStore } from '@maximizer/outlook/shared/data-access';
import { TaskSummary } from '@maximizer/outlook/shared/domain';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TaskService } from '@maximizer/outlook/task/data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { catchError, finalize } from 'rxjs';

@Component({
  selector: 'maximizer-summary-task',
  templateUrl: './summary-task.component.html',
  imports: [DatePipe, OUTLOOK_SHARED_UI, TranslatePipe, UI_PIPES],
})
export class SummaryTaskComponent extends EmbeddedComponent implements OnInit {
  @Output() loadErrorEvent: EventEmitter<string> = new EventEmitter();
  @Output() loadingEvent: EventEmitter<boolean> = new EventEmitter();

  loading = true;

  @Input() deepLink?: string;
  @Input() type?: string;
  @Input() id?: string;

  configuration: TaskSummary;

  constructor(
    element: ElementRef,
    private readonly taskService: TaskService,
    readonly outlookStore: OutlookStore,
  ) {
    super(element);
    this.configuration = { overdueTaskAmount: 0, upcomingTaskAmount: 0 };
  }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    if (!this.id || !this.type) return;
    this.taskService
      .getSummary(this.id, this.type)
      .pipe(
        catchError(async () => this.loadErrorEvent.emit('task')),
        finalize(() => {
          this.loadingEvent.emit(false);
          this.loading = false;
        }),
      )
      .subscribe((data) => {
        if (!data) return;
        if (data.overdueTaskAmount > 0) {
          data.overdueTaskAmount = data.overdueTaskAmount - 1;
        }
        if (data.upcomingTaskAmount > 0) {
          data.upcomingTaskAmount = data.upcomingTaskAmount - 1;
        }
        this.configuration = data;
      });
  }
}
